import { render } from "./DataFlowDiagramEndpointBox.vue?vue&type=template&id=4bac1f68"
import script from "./DataFlowDiagramEndpointBox.vue?vue&type=script&lang=js"
export * from "./DataFlowDiagramEndpointBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__